import styled from 'styled-components'
import { P } from '@farewill/ui'
import { COLOR, GTR } from '@farewill/ui/tokens'

const StyledTotals = styled(P)`
  display: flex;
  flex-wrap: wrap;
  column-gap: ${GTR.S};
`

type Props = {
  total: string
  sole?: string
  joint?: string
  soleLabel?: string
  jointLabel?: string
  breakdown?: { label: string; value: string }[]
}

const SectionTotals = ({
  total,
  sole,
  joint,
  soleLabel = 'Solely owned',
  jointLabel = 'Share of jointly owned',
  breakdown = [],
}: Props) => (
  <StyledTotals color={COLOR.GREY.DARK} margin={[0, 0, 'S']}>
    <span>Total: {total}</span>
    {sole && (
      <span>
        {soleLabel}: {sole}
      </span>
    )}
    {joint && (
      <span>
        {jointLabel}: {joint}
      </span>
    )}
    {breakdown.map(({ label, value }) => (
      <span key={label}>
        {label}: {value}
      </span>
    ))}
  </StyledTotals>
)

export default SectionTotals
